import { can } from "@/lib/permissions";
import type { MyPermissions } from "@/types/authorization";

/** Build an approval-engine API path (org is resolved server-side, like getCrmUrl). */
export function getApprovalUrl(path: string): string {
  return `/api/leave/approvals/${path}`;
}

/**
 * Whether the supervisor area exists for this user.
 *
 * Purely relational: whose requests reach you is a property of the people who
 * report to you, never of a role. There is deliberately no permission here —
 * a designated approver holds none, and the server's approval chains resolve
 * from `UserSupervisor` rows, not from capabilities.
 */
export function isSupervisorUser(
  capabilities?: MyPermissions | null
): boolean {
  return capabilities?.has_subordinates === true;
}

/**
 * Whether approval work can land on this user: a supervisor, or a holder of an
 * approve code (the fallback approver when a requester has no supervisor
 * levels). Decides who is shown approval counts and notifications outside the
 * supervisor area (T-165).
 */
export function receivesApprovals(
  capabilities?: MyPermissions | null
): boolean {
  return (
    isSupervisorUser(capabilities) ||
    can(capabilities, "leave.request.approve") ||
    can(capabilities, "attendance.overtime.approve")
  );
}
